import React, { useMemo } from "react";
import FormalitiesRequestStatusDropdown from "./FormalitiesRequestStatusDropdown";

export default function FormalityRequestsFilter({
  // Search
  search = "",
  onSearchChange,

  // Month
  monthFilter = "",
  onMonthChange,

  // Status
  statuses = {},
  statusFilter = "all",
  onStatusChange
}) {
  // --------------------------------------------------
  // Statuts actifs uniquement (hors "all")
  // --------------------------------------------------
  const activeStatuses = useMemo(() => {
    return Object.fromEntries(
      Object.entries(statuses).filter(
        ([key, status]) => key !== "all" && status?.active !== false
      )
    );
  }, [statuses]);

  return (
    <div className="d-flex justify-content-between align-items-center">

      {/* SEARCH INPUT */}
      <div style={{ flexGrow: 1 }} className="me-3">
        <input
          type="text"
          className="form-control"
          placeholder="Rechercher"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </div>

      {/* RIGHT SIDE : MONTH + STATUS */}
      <div className="d-flex align-items-center gap-2">

        {/* MONTH PICKER */}
        <input
          type="month"
          className="form-control"
          style={{ width: "170px" }}
          value={monthFilter}
          onChange={(e) => onMonthChange(e.target.value)}
        />

        {/* STATUS DROPDOWN */}
        <FormalitiesRequestStatusDropdown
          statuses={activeStatuses}
          selected={statusFilter}
          onChange={onStatusChange}
          disabled={false}
          size=""
          includeAll
        />

      </div>
    </div>
  );
}
